export class StateMapRequest {
    public areaType: number;
    public grades: number[];
    public programsOffered: number[];
}

export class PovertyMapRequest extends StateMapRequest {
    public age: number;
    public type: number;
}

export class RaceEthnicityMapRequest extends StateMapRequest {
    public year: string;
    public race: string;    
    public ageGroup: string;
    public sex: string;    
}

export class EducationalAttainmentMapRequest extends StateMapRequest {
    public year: string;
}

export class EmploymentMapRequest extends StateMapRequest {
    public year: string;
    public field: number;
}

export class HousingMapRequest extends StateMapRequest {
    public field: string;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/map/state-map-request.ts